export * from '../src/composites/wui-icon-link/index.js';
//# sourceMappingURL=wui-icon-link.js.map